import { connect } from 'react-redux'
import { mobileMenuDispatchers as dispatchSelector } from 'reduxModules/menuItem/dispatchers'
import { mobileMenuSelector as stateSelector } from 'reduxModules/menuItem/selectors'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import classnames from 'classnames'
import getOptions from '../NavBar/options'
import { getActiveSection, getActiveSubsection } from '../NavBar/utils'
import './styles.css'

export class MobileSideBar extends Component {
  render() {
    const { props } = this
    const activeSection = getActiveSection(props.pathName)
    return (
      <div
        id="MobileSideBar"
        style={{ height: `${props.height}px` }}
      >
        <div className="menu-items">
          <div className="home-btn">
            <Link
              to="/"
              onClick={() => props.toggleMobileMenu()}
            >
              <div
                className={classnames('home-btn-container', { current: activeSection === 'home' })}
              >
                <i className="icon-home" aria-hidden="true" />
                <span>home</span>
              </div>
            </Link>
          </div>
          {getOptions(true).map((item, itemIndex) => {
            const title = item.title.toLowerCase()
            return (
              <div
                key={itemIndex}
                className="menu-item"
              >
                <div
                  className={classnames('category', {
                    expanded: title === props.active || title === activeSection,
                    expandable: _.has(item, 'options'),
                    current: title === activeSection
                  })}
                  onClick={title !== props.active ? () => props.showMenuItem(title) : () => props.hideMenuItem(title)}
                >
                  <div className="title">
                    {(!_.has(item, 'options') || _.has(item, 'url')) && (
                      <Link
                        to={item.url}
                        onClick={() => props.toggleMobileMenu()}
                      >
                        <span>{item.title}</span>
                      </Link>
                    )}
                    {_.has(item, 'options') && !_.has(item, 'url') && (
                      <span>{item.title}</span>
                    )}
                  </div>
                  {_.has(item, 'options') && (
                    <div className="arrow">
                      <i className="icon-right-2" aria-hidden="true" />
                    </div>
                  )}
                </div>
                {(title === props.active || title === activeSection) && (
                  <div className="options">
                    {item.options && item.options.map((option, optionIndex) => (
                      <React.Fragment key={optionIndex}>
                        {!option.isExternal && (
                          <Link
                            to={option.url}
                            className={classnames({ current: option.title.toLowerCase() === getActiveSubsection(props.pathName) })}
                            onClick={() => props.toggleMobileMenu()}
                          >
                            {option.title}
                          </Link>
                        )}
                        {option.isExternal && (
                          <a href={option.url} target="_blank" rel="noreferrer">{option.title}</a>
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                )}
              </div>
            )
          })}
          {props.isLoggedIn && (
            <div className="account-btn">
              <Link
                to="/account"
                onClick={() => props.toggleMobileMenu()}
              >
                <div
                  className={classnames('account-btn-container', { current: activeSection === 'account' })}
                >
                  <i className="icon-account" aria-hidden="true" />
                  <span>account</span>
                </div>
              </Link>
            </div>
          )}
          <div className="account-btn">
            <Link
              to="/cart"
              onClick={() => props.toggleMobileMenu()}
            >
              <div
                className={classnames('account-btn-container', { current: activeSection === 'cart' })}
              >
                <i className="icon-cart" aria-hidden="true" />
                <span>Cart</span>
              </div>
            </Link>
          </div>
          <div className="account-btn">
            {props.isLoggedIn && (
              <div
                onClick={() => props.logout()}
                className="logout-btn"
              >
                <div className="account-btn-container">
                  <i className="icon-logout" aria-hidden="true" />
                  <span>logout</span>
                </div>
              </div>
            )}
            {!props.isLoggedIn && (
              <Link
                to={{ pathname: '/login', state: { next: props.pathName } }}
                onClick={() => props.toggleMobileMenu()}
                className="login-btn"
              >
                <div className="account-btn-container">
                  <i className="icon-login" aria-hidden="true" />
                  <span>login</span>
                </div>
              </Link>
            )}
          </div>
        </div>
      </div>
    )
  }
}

MobileSideBar.propTypes = {
  active: PropTypes.string,
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  hideMenuItem: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  logout: PropTypes.func.isRequired,
  pathName: PropTypes.string.isRequired,
  showMenuItem: PropTypes.func.isRequired,
  toggleMobileMenu: PropTypes.func.isRequired
}

MobileSideBar.defaultProps = {
  active: null,
  height: 0,
  width: 0
}

export default connect(
  stateSelector,
  dispatchSelector
)(MobileSideBar)
